import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { MKT } from '../../Marketing/links';
const QUESTIONS = [
    [
        'Which auctions can you bid at?',
        'USS, TAA, HAA, JU, CAA, Arai and the rest: the more houses, the more lots you see.'
    ],
    [
        'What’s your fee per car?',
        'Flat or a percentage, and what it includes. Ask for a sample invoice with every line on it.'
    ],
    [
        'What deposit do you need, and when is it refunded?',
        'Deposits range from nothing to a few thousand dollars; know how quickly you get it back.'
    ],
    [
        'How fast do I get the auction sheet?',
        'Before the auction, in full resolution, for every lot you ask about.'
    ],
    [
        'Can you get extra photos or an inspection?',
        'Especially underneath, and on high-value cars.'
    ],
    [
        'How do you translate the sheet?',
        'Human notes on the inspector’s comments are worth more than a machine read of the grades.'
    ],
    [
        'How do bids work?',
        'Do you set a maximum, can you bid live, and what happens if two lots you want run at once?'
    ],
    [
        'How quickly must I pay after a win?',
        'Most expect payment within days. Ask about currency, Wise versus wire, and the rate on the invoice.'
    ],
    [
        'How do you handle damage claims?',
        'If the car arrives at the port with damage the sheet didn’t show, what can the agent recover from the auction?'
    ],
    [
        'How do you ship?',
        'RoRo or container, which ports, how often, and who books the freight and insurance.'
    ],
    [
        'What paperwork do I get, and when?',
        'Export certificate, translation, bill of lading, commercial invoice: ask for originals early.'
    ],
    [
        'Can I see past results?',
        'Sold prices from their account help you set bids. A good agent shares them.'
    ]
];
export default function ExportAgent() {
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("p", {
                children: "Japanese dealer auctions are members-only, so unless you hold a Japanese dealer licence yourself, every car you buy goes through a Japanese export agent. The agent bids for you, pays the auction, deregisters the car, books the shipping and sends you the paperwork. They set a lot of your cost and most of your risk, so it’s worth choosing carefully."
            }),
            /*#__PURE__*/ _jsx("h2", {
                children: "Twelve questions for a Japanese export agent"
            }),
            /*#__PURE__*/ _jsx("ol", {
                children: QUESTIONS.map(([q, a])=>/*#__PURE__*/ _jsxs("li", {
                        children: [
                            /*#__PURE__*/ _jsx("strong", {
                                children: q
                            }),
                            " ",
                            a
                        ]
                    }, q))
            }),
            /*#__PURE__*/ _jsx("h2", {
                children: "Fees: read the whole invoice"
            }),
            /*#__PURE__*/ _jsxs("p", {
                children: [
                    "The agent’s service fee is one line of several. On a real five-car shipment in August 2026 the Japan-side lines were a flat ¥100,000 agent fee per car, an auction fee around ¥20,000, inland transport to the port of ¥12,000–34,000, insurance around ¥10,000 and RoRo freight for a kei car around ¥170,000. Your numbers will differ: compare agents on the total, not the headline fee. Our ",
                    /*#__PURE__*/ _jsx("a", {
                        href: "/blog/jdm-import-cost-calculator",
                        children: "import cost calculator"
                    }),
                    ' ',
                    "adds the US side."
                ]
            }),
            /*#__PURE__*/ _jsx("h2", {
                children: "Why many shops use more than one agent"
            }),
            /*#__PURE__*/ _jsx("p", {
                children: "No agent covers every auction equally, and agents differ in how fast they turn sheets and photos around. Many import shops keep accounts with two or three, to see more lots and to have a backup when one is slow. The cost is more logins, more invoices in yen at different rates, and more places to search."
            }),
            /*#__PURE__*/ _jsxs("p", {
                children: [
                    "Right Hand DMS searches across your JapanCarDirect, JDM Auc and Pacific Coast JDM accounts at once and keeps every invoice’s exchange rate against the car, so a second agent doesn’t mean a second spreadsheet: see ",
                    /*#__PURE__*/ _jsx("a", {
                        href: MKT.product('search'),
                        children: "auction search"
                    }),
                    " and",
                    ' ',
                    /*#__PURE__*/ _jsx("a", {
                        href: MKT.product('landed-cost'),
                        children: "landed cost"
                    }),
                    ". Use a different agent?",
                    ' ',
                    /*#__PURE__*/ _jsx("a", {
                        href: MKT.bookCall,
                        children: "Tell us which"
                    }),
                    "."
                ]
            })
        ]
    });
}
